import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const name = <FormattedMessage {...messages.productTypeColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.productTypeColumnHeader,
  name,
  render: (data) => data.productType || '',
};
